import { useLocation } from "react-router-dom";

import CustomTooltip from "@/components/desktop/tooltip/CustomTooltip";
import CustomBadge from "@/components/desktop/badge/CustomBadge";

import { ReactComponent as ArrowUpSvg } from "@/assets/images/desktop/Flechaverdehorizontal.svg";
import { ReactComponent as ArrowDownSvg } from "@/assets/images/desktop/flechaverdeabajo.svg";

import { agricolaName, initialText, dateToLocale, formatMiles, formatMilesDecimal } from "@/services/Utils";
import OrdersDeliveryActionItem from "./Action/OrdersDeliveryActionItem";
import OrdersDeliveryTableBodyDetail from "./OrdersDeliveryTableBodyDetail";

import classes from "../../purchase.module.scss";

const originTypeMapping = [
	{ key: "transfer", label: "Traspasos", variant: "warning" },
	{ key: "implementation", label: "Carga Inicial", variant: "success" },
	{ key: "unassigned", label: "Sin Asignar", variant: "secondary" },
	{ key: "restore", label: "Restaurado", variant: "info" },
	{ key: "taking", label: "Toma de Inventario", variant: "info" },
];

const columnExclusionsConfig = {
	sin_documento: ["dealer_name", "delivery_number", "orders_sale", "date_orders_delivery"],
	guias_despacho: ["origin_type"],
};

const OrdersDeliveryTableBody = ({ data, setData, base }) => {
	let location = useLocation();

	const excludedColumns = Object.entries(columnExclusionsConfig).reduce((exclusions, [key, columns]) => {
		return location.pathname.includes(key) ? exclusions.concat(columns) : exclusions;
	}, []);

	return (
		<tbody>
			{data &&
				data.map((item, i) => {
					return [
						<tr key={i} className={`${classes.table_tr} ${item.active && classes.thisActive}`}>
							{!excludedColumns.includes("business_name") && (
								<td className={`${classes.table_td} ${classes.first_td}`}>
									<div
										className={`${classes.table_div} ${item.pending_tags && classes.pending_tag} ${classes.long_text} ${
											item.active && classes.active
										} ${classes.long_text} ${classes.first_div}`}
									>
										<CustomTooltip text={agricolaName(item.business_name)} description={item.business_name} />
									</div>
								</td>
							)}
							{!excludedColumns.includes("created_date") && (
								<td className={`${classes.table_td}`}>
									<div className={`${classes.table_div} ${item.pending_tags && classes.pending_tag} ${item.active && classes.active}`}>
										{item && item.created_date && dateToLocale(item.created_date)}
									</div>
								</td>
							)}
							{!excludedColumns.includes("origin_type") && (
								<td className={`${classes.table_td}`}>
									<div className={`${classes.table_div} ${item.pending_tags && classes.pending_tag} ${item.active && classes.active}`}>
										{item && item.origin_type && (
											<>
												{originTypeMapping.map((map) => {
													if (item.origin_type.toLowerCase().includes(map.key.toLowerCase())) {
														return (
															<CustomBadge style={{ fontSize: "10px" }} key={map.key} variant={map.variant}>
																{map.label}
															</CustomBadge>
														);
													}
													return null;
												})}
											</>
										)}
									</div>
								</td>
							)}
							{!excludedColumns.includes("dealer_name") && (
								<td className={`${classes.table_td}`}>
									<div
										className={`${classes.table_div} ${item.pending_tags && classes.pending_tag} ${classes.long_text} ${
											item.active && classes.active
										}`}
										style={{ textAlign: "center" }}
									>
										<CustomTooltip
											text={item.dealer_name.length < 5 ? item.dealer_name : agricolaName(item.dealer_name)}
											description={item.dealer_name}
										/>
									</div>
								</td>
							)}
							{!excludedColumns.includes("delivery_number") && (
								<td className={`${classes.table_td}`}>
									<div className={`${classes.table_div} ${item.pending_tags && classes.pending_tag} ${item.active && classes.active}`}>
										{item && item.delivery_number}
									</div>
								</td>
							)}
							{!excludedColumns.includes("orders_sale") && (
								<td className={`${classes.table_td}`}>
									<div
										className={`${classes.table_div} ${item.active && classes.active} ${classes.long_text} ${classes.list} ${
											item.pending_tags && classes.pending_tag
										}`}
									>
										{item &&
											item.orders_sale &&
											item.orders_sale.length !== 0 &&
											item.orders_sale.map((o, k) => {
												return (
													<p
														style={{
															marginBottom: "0px",
														}}
														key={k}
													>
														<a
															key={k}
															href={`/facturas/ver/${o.code}`}
															target="__blank"
															style={{
																color: "black",
																fontWeight: "400",
															}}
														>
															{`${o.dealer_number} `}
														</a>
													</p>
												);
											})}
									</div>
								</td>
							)}
							{!excludedColumns.includes("date_orders_delivery") && (
								<td className={`${classes.table_td}`}>
									<div className={`${classes.table_div} ${item.pending_tags && classes.pending_tag} ${item.active && classes.active}`}>
										{item && item.date_orders_delivery && dateToLocale(item.date_orders_delivery)}
									</div>
								</td>
							)}
							{!excludedColumns.includes("quantity") && (
								<td className={`${classes.table_td}`}>
									<div className={`${classes.table_div} ${item.pending_tags && classes.pending_tag} ${item.active && classes.active}`}>
										{item && item.quantity && formatMiles(item.quantity)}
									</div>
								</td>
							)}
							{!excludedColumns.includes("price_total") && (
								<td className={`${classes.table_td}`}>
									<div className={`${classes.table_div} ${item.pending_tags && classes.pending_tag} ${item.active && classes.active}`}>
										${item && item.price_total && formatMilesDecimal(item.price_total)}
									</div>
								</td>
							)}
							{!excludedColumns.includes("user_name") && (
								<td className={`${classes.table_td}`}>
									<div className={`${classes.table_div} ${item.pending_tags && classes.pending_tag} ${item.active && classes.active}`}>
										<CustomTooltip text={initialText(item.user_name)} description={item.user_name} />
									</div>
								</td>
							)}
							<td className={`${classes.table_td}`}>
								<div
									className={`${classes.table_div} ${item.pending_tags && classes.pending_tag} ${item.active && classes.active}`}
									style={{ position: "relative" }}
								>
									<OrdersDeliveryActionItem item={item} indice={i} data={data} base={base} />
								</div>
							</td>
							<td
								onClick={() => {
									let newData = [...data];
									newData.forEach((element, j) => {
										if (!newData[i].active) {
											newData[j].active = false;
										}
									});
									newData[i].active = !newData[i].active;
									setData(newData);
								}}
								className={`${classes.table_td}`}
							>
								<div
									className={`${classes.table_div} ${item.pending_tags && classes.pending_tag} ${item.active && classes.active} ${
										classes.last_div
									}`}
								>
									{item.active ? <ArrowDownSvg /> : <ArrowUpSvg />}
								</div>
							</td>
						</tr>,
						<OrdersDeliveryTableBodyDetail item={item} key={`detail_${i}`} />,
					];
				})}
		</tbody>
	);
};

export default OrdersDeliveryTableBody;
